import(/* webpackMode: "eager" */ "/home/ignacio/Documents/REPOSITORY/WEBSITES/Apex-Experience/apex-next/app/[locale]/lodges/apex-mountain-penthouse/page.tsx");
